<svelte:options accessors={true}/>
<script>
    import {onMount} from 'svelte';
    import ReportsService from "../../services/reports.service";
    import Loader from "../../components/Loader.svelte";
    import EditableCell from "../../components/EditableCell.svelte";
    import AuthService from '../../services/auth.service.js';
    import {formatValue, cleanValue} from '../../helpers/format.helper';
    import {getPastDateData, getPtqrCellStyle, stylesList} from '../../helpers/style.helper';
    import ExportRoasService from "../services/roas_export.service";
    import OperationsColorPicker from "../components/OperationsColorPicker.svelte";

    let teams, headers, loading = true, saveTried = true, saveTriedAlert = false,
        employeeToChange = {}, deleteConfirmation = false, badDatesError = false,
        errorMessage,
        roleName = '',
        disableButton = false,
        disableSaveButton = false,
        currentEmployee = {}, roleToChange = {}, currentRole = {},
        selectedTeam = null,
        teamDragged,
        categoryInfo,
        isActualsVsBudgets = false,
        totals = {},
        budgets = {},
        pyData = {},
        employeeError = '',
        roleFilledFields = false,
        employeeFilledFields = false;

    export let user, params, options, loadingExport = false;

    const formatTitles = [
        'Numeric', 'Currency ($)', 'Percentage (%)', 'Days', 'Multiplier (x)', 'B.P.S. (bps)'
    ];

    const monthNames = ['', 'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    $: loadData(params);

    $: roleFilledFields = currentRole.title && currentRole.actual_title && currentRole.budget_title
      && currentRole.delta_title && currentRole.kpi_title;

    $: employeeFilledFields = currentEmployee.region && currentEmployee.employee_number &&
      currentEmployee.name && currentEmployee.position && currentEmployee.office && 
      currentEmployee.start_date;

    export async function loadData() {
        isActualsVsBudgets = params.subMenu === 'actuals_vs_budget';
        loading = true;
        selectedTeam = null;
        deleteConfirmation = false;
        const url = `/org/${params.org}/individual/${params.subMenu}/date/${params.year}/${params.month}`;
        let result = null;
        //Scroll to previous position
        setTimeout(() => {
            var scrolled = (localStorage.getItem('scrolled')) ? localStorage.getItem('scrolled') : 0;
            jQuery('#reportsDiv').scrollTop(scrolled);
            localStorage.setItem("scrolled", 0);
        }, 500);
        teams = [];
        try {
            result = await ReportsService.load(url);
        } catch (e) {
            teams = null;
        }

        if (result && result.data && result.data.headers) {
            teams   = result.data.roles;
            headers = result.data.headers;
            budgets = result.data.budgets;
            pyData  = result.data.py;

            getTotals();
        }

        loading = false;

        setTimeout(() => {
            jQuery('.sticky-thead').removeClass('d-none');
            tablesLoaded();
            enableTableSelection();
        }, 500);
    }

    onMount(() => {
        cleanEmployee();
        loadData();
    });

    function getRows(employeesCount) {
        var rows = [];
        for (let i = 0; i < 1 - employeesCount; i++) {
            rows.push(i);
        }
        return rows;
    }

    let saveEmployeeStat = async function (value, op_employee_id, date, field, employeeIndex, roleIndex) {
        updateReadOnlyColumns(value, field, date, employeeIndex, roleIndex);
        const valueMonth = monthNames.indexOf(date) ;
        await ReportsService.saveEmployeeStat({
            op_employee_id,
            date: `${params.year}-${valueMonth}-01`,
            [field]: value
        });
        getTotals();
    }

    let updateReadOnlyColumns = function (value, field, date, employeeIndex, roleIndex) {
        teams[roleIndex].employees[employeeIndex].employeeData[date][field] = value;
        let employeeData = teams[roleIndex].employees[employeeIndex].employeeData[date];
        let parameter1 = employeeData.parameter1;
        let parameter2 = employeeData.parameter2;

        teams[roleIndex].employees[employeeIndex].employeeData[date] = {
            utilization_rate: parameter2 ? (parameter2 * 100 / parameter1).toFixed(2) : 0,
            parameter1,
            parameter2,
            open_utilization: parameter1 - parameter2
        }
        // Calculate totals
    }

    let saveEmployeeFields = async function (value, employee_id, field) {
        let employeeUpdated = {
            id: employee_id
        };
        employeeUpdated[field] = value;
        console.log('data: ', employeeUpdated);
        await ReportsService.updateEmployee(employeeUpdated);
    }

    let onSaveEmployee = async function () {
        employeeError = '';
        let result = null;
        if (!employeeFilledFields) {
            saveTried = true;
            saveTriedAlert = true;
            setTimeout(() => {
                saveTriedAlert = false;
            }, 3000);
        } else {
            if (currentEmployee.end_date && !(currentEmployee.start_date <= currentEmployee.end_date)) {
                badDatesError = true;

                setTimeout(() => {
                    badDatesError = false;
                }, 3000);
            } else {
                disableSaveButton = true;
                errorMessage = null;
                let response = null;

                try {
                    if (currentEmployee.id) {
                        if (JSON.stringify(employeeToChange) != JSON.stringify(currentEmployee)) {
                            result = await ReportsService.updateEmployee(currentEmployee);
                        }
                    } else {
                        result = await ReportsService.saveEmployee(currentEmployee);
                    }
                    verifyEmployeeNumber(result);
                } catch (e) {
                    errorMessage = e.message;
                }
            }
        }
    }

    let verifyEmployeeNumber = function (result) {
        disableSaveButton = false;
        if (result && result.data && result.data.error) {
            employeeError = result.data.error;
            setTimeout(() => {
                employeeError = '';
            }, 5000);
            return;
        }
        loadData();
        jQuery('#addEmployee').modal('hide');
        cleanEmployee();
    }

    let onSaveTeam = async function () {
        disableSaveButton = true;
        errorMessage = null;

        if (!roleFilledFields) {
            saveTriedAlert = true;
            setTimeout(() => {
                saveTriedAlert = false;
            }, 5000);
        } else {
            try {
                if (currentRole.id) {
                    if (JSON.stringify(roleToChange) != JSON.stringify(currentRole)) {
                        await ReportsService.updateTeam(currentRole);
                        loadData();
                    }
                } else {
                    await ReportsService.saveTeam(currentRole);
                    loadData();
                }
                disableSaveButton = false;
                jQuery('#editRole').modal('hide');
                currentRole = {}; //"Clean" it
            } catch (e) {
                errorMessage = e.message;
            }
        }

    }

    let onDeleteEmployee = async function () {
        errorMessage = null;
        disableButton = true;

        try {
            await ReportsService.deleteEmployee(currentEmployee.id);
            jQuery('#addEmployee').modal('hide');
            deleteConfirmation = false;
            cleanEmployee();
            loadData();
        } catch (e) {
            errorMessage = e.message;
        }
    }

    let onDeleteTeam = async function () {
        disableButton = true;
        errorMessage = null;

        try {
            await ReportsService.deleteTeam(currentRole.id);
            jQuery('#editRole').modal('hide');
            deleteConfirmation = false;
            loadData();
        } catch (e) {
            errorMessage = e.message;
        }
    }

    async function changeTeamPosition(teamId, newPosition) {
        if (selectedTeam != teamId) {
            try {
                await ReportsService.updateTeamPosition({id: selectedTeam, position: newPosition});
                loadData();
            } catch (e) {
                console.log(e);
            }
        }
        selectedTeam = null;
    }

    function onSelectTeam(teamId) {
        selectedTeam = teamId;
        jQuery('.sticky-thead').addClass('d-none');
    }

    let setDeleteConfirmation = function () {
        deleteConfirmation = true;
        setTimeout(() => {
            if (deleteConfirmation) deleteConfirmation = false;
        }, 10000);
    }

    function cleanEmployee() {
        currentEmployee = {
            region: '',
            employee_number: '',
            name: '',
            office: '',
            position: '',
            is_fulltime: 0,
            op_role_id: null,
            skills: ''
        };
        saveTried = false;
    }

    function cleanRole() {
        currentRole = {
            title: '',
            organization_id: params.org,
            kpi_title: '',
            actual_title: '',
            budget_title: '',
            delta_title: '',
            taxonomy: '',
            format: 0,
            style: null
        };
    }

    function fillEmployee(role) {
        cleanEmployee();
        roleName = role.title;
        currentEmployee.op_role_id = role.id;
        jQuery('#employee-tab').click();
        jQuery('#addEmployee').modal('show');
    }

    function editEmployee(e, employee) {
        currentEmployee = employee;
        deleteConfirmation = false;
        disableButton = false;
        saveTried = false;

        if (currentEmployee.start_date_formatted) {
            var startDateSplitted = currentEmployee.start_date_formatted.split("/");
            currentEmployee.start_date = startDateSplitted[2] + "-" + startDateSplitted[0] + "-" + startDateSplitted[1];
        }

        if (currentEmployee.end_date_formatted) {
            var endDateSplitted = currentEmployee.end_date_formatted.split("/");
            currentEmployee.end_date = endDateSplitted[2] + "-" + endDateSplitted[0] + "-" + endDateSplitted[1];
        }
        jQuery('#employee-tab').click();
        employeeToChange = {...currentEmployee};
        jQuery('#addEmployee').modal('show');
    }

    function editRole(role) {
        currentRole = role;
        deleteConfirmation = false;
        disableButton = false;
        roleToChange = {...currentRole}; // Used to verify if at least a field change
        jQuery('#editRole').modal('show');
    }

    export function addSection() {
        cleanRole();
        jQuery('#editRole').modal('show');
    }

    function getUtilizationColor(value, budget, style, roleId, month) {
        if (!style || !JSON.parse(style)) return;

        style = JSON.parse(style);

        value = parseFloat(value);

        switch (true) {
            case Math.abs(Math.abs(value) - Math.abs(budget)) <= style.range1:
                return `style-${style.range1_color}`;
            
            case Math.abs(Math.abs(value) - Math.abs(budget)) <= style.range2:
                return `style-${style.range2_color}`;

            default:
                return `style-${style.else_color}`;
        }
    }

    async function saveBudget (budget, roleId, date, roleIndex) {
        const valueMonth = monthNames.indexOf(date) ;
        const fields = {
            budget,
            op_role_id: roleId,
            date: `${params.year}-${valueMonth}-01`
        }
        await ReportsService.saveRoleBudget(fields);
    }

    export async function exportToExcel(allPortcos = false) {
        const isFacilitator = (AuthService.can('EXPORT_HR_ALL_PORTCOS') && allPortcos)?false : true;
        const urlToExport = '/org/' + params.org + getExportUrl(isFacilitator) + params.year;
        const fileName = (!isFacilitator)? 'Individual -' + params.year:`Individual-${jQuery('#dropdownOrganizations').text()}` + "-" + params.year;
        let result = null;
        loadingExport = true;
        try {
            result = await ReportsService.load(urlToExport);
            if (result && result.data) {
                await ExportRoasService.downloadIndividual(result.data, user.name, fileName);
            } else {
                alert('No sections found');
            }
        } catch (e) {
            alert('Download error!');
            console.log('Error', e);
        }

        loadingExport = false;
    }

    function getExportUrl(isFacilitator){
        return (isFacilitator) ? '/export/individual/date/' : '/export/individual_all_portcos/date/';
    }

    function getDate(month) {
        return params.year + '-' + monthNames.indexOf(month).toString().padStart(2, '0') + '-01';
    }

    function handleDragStart(e, id, teamId) {
        teamDragged = teamId;
        e.dataTransfer.dropEffect = "move";
        e.dataTransfer.setData("text", id);
    }

    function handleDragEnter(e) {
        e.dataTransfer.dropEffect = "move";
        window.jQuery(e.target).css('border-top', '2px dashed #fdc59b');
        window.jQuery(e.target).css('box-shadow', 'inset 0 0 10px #fdc59b');
    }

    function handleDragLeave(e) {
        console.log(e.target);
        window.jQuery(e.target).css('border-top', '1px solid #dee2e6');
        window.jQuery(e.target).css('box-shadow', 'none');
    }

    async function handleDrop(e, team_id, position) {
        e.preventDefault();
        let id = e.dataTransfer.getData("text");

        try {
            await ReportsService.updateEmployeePosition({id, team_id, position});
            loadData();
        } catch (e) {
            console.log(e);
        }
    }

    let openCategoryInfo = function(category){
        console.log("category",category)
        categoryInfo = category;
        jQuery('#categoryInfoModal').modal('show');
    }

    function getTotals () {
        teams.map((team, index) => {
            totals[index] = {};
            team.employees.map(employee => {
                Object.keys(employee.employeeData).map(header => {
                    if (totals[index][header] === undefined) totals[index][header] = {};
                    Object.keys(employee.employeeData[header]).map(field => {
                        if (totals[index][header][field] === undefined) totals[index][header][field] = 0;
                        totals[index][header][field] += parseFloat(employee.employeeData[header][field]);
                    });
                })
            });
        });
        console.log('totals: ', totals);
    }
</script>
<button class="d-none" id="reloadData" on:click={loadData}>RELOAD</button>

<div class="modal fade" id="editRole" tabindex="-1" role="dialog" aria-labelledby="editRole" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="editRoleLabel">
                    {#if currentRole.id}
                        Edit
                    {:else}
                        Add
                    {/if} Role
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {#if AuthService.can('EDIT_TEAM') }
                    {#if saveTriedAlert}
                        <div class="alert alert-danger" role="alert">
                            Please fill in all required fields
                            <button type="button" class="close" on:click={ () => saveTriedAlert = false}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    {/if}
                    <ul class="nav nav-tabs mb-2" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="section-edit-tab"
                               data-toggle="tab" href="#sectionEdit" role="tab" aria-controls="role"
                               aria-selected="true">
                                Role
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="kpi-tab"
                               data-toggle="tab" href="#kpi" role="tab" aria-controls="kpi"
                               aria-selected="true">
                                KPI
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="style-tab"
                                data-toggle="tab" href="#style" role="tab" aria-controls="style"
                                aria-selected="false">
                                Conditional Formatting
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content" id="myTabContent">

                        <div class="tab-pane fade show active" id="sectionEdit" role="tabpanel" aria-labelledby="style-tab">
                            <div class="form-group">
                                <label for="teamName">* Role Name:</label>
                                <input bind:value={currentRole.title} maxlength="64" type="text" class="form-control" id="teamName"
                                    placeholder="Role Name">
                            </div>
                            
                            <label id="column-names">Column Names</label>

                            <div class="row mt-2">
                                <div class="col-md-3">
                                    <label>* Actual: </label>
                                </div>
                                <div class="col-md-9">
                                    <input bind:value={currentRole.actual_title} maxlength="64" type="text" class="form-control" id="roleActual"
                                    placeholder="i.e: Billed Hours">
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-md-3">
                                    <label>* Budget: </label>
                                </div>
                                <div class="col-md-9">
                                    <input bind:value={currentRole.budget_title} maxlength="64" type="text" class="form-control" id="roleBudget"
                                    placeholder="i.e: Total Hours">
                                </div>
                            </div>
                            <div class="row mt-4 mb-2">
                                <div class="col-md-3">
                                    <label>* Delta: </label>
                                </div>
                                <div class="col-md-9">
                                    <input bind:value={currentRole.delta_title} maxlength="64" type="text" class="form-control" id="roleDelta"
                                    placeholder="i.e: Open Utilizations">
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane fade " id="kpi" role="tabpanel" aria-labelledby="kpi-tab">
                            <div class="form-group">
                                <label for="teamName">* KPI Name:</label>
                                <input bind:value={currentRole.kpi_title} maxlength="64" type="text" class="form-control" id="teamName"
                                    placeholder="KPI Name">
                            </div>

                            <div class="form-group">
                                <label for="teamName">Taxonomy & Definitions:</label>
                                <textarea bind:value={currentRole.taxonomy} type="text" class="form-control"
                                    id="taxonomyInput" placeholder="Taxonomy & Definitions" rows="5"></textarea>
                            </div>

                            <div class="form-group">
                                <label for="formatInput">Format:</label>
                                <select bind:value={currentRole.format} class="form-control" id="formatInput">
                                    {#each formatTitles as name, id}
                                        <option value={id}>{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>

                        <div class="tab-pane fade " id="style" role="tabpanel" aria-labelledby="style-tab">
                            <div class="form-group">
                                <label>
                                    <input type=radio name="customStyle"
                                        checked="{ !currentRole.style || currentRole.style.length == 0 }"
                                        on:click={() => currentRole.style=''}>
                                    Default
                                </label>
                                <label class="ml-3">
                                    <input type=radio name="customStyle"
                                        checked="{ currentRole.style && currentRole.style.length > 0 }"
                                        on:click={() => currentRole.style=stylesList[4].code}>
                                    Custom
                                </label>
                            </div>
                            {#if currentRole.style && currentRole.style.length > 0 }
                                <OperationsColorPicker bind:value={currentRole.style}></OperationsColorPicker>
                            {/if}
                        </div>
                    </div>
                {/if}
            </div>
            <div class="modal-footer text-right">
                {#if AuthService.can('DELETE_TEAM') }
                    {#if currentRole.id}
                        {#if deleteConfirmation}
                            <button type="button" class="btn btn-danger mr-auto" on:click={onDeleteTeam}
                                    disabled={disableButton}>
                                Click to confirm
                            </button>
                        {:else}
                            <button type="button" class="btn btn-danger mr-auto" on:click={setDeleteConfirmation}>
                                DELETE
                            </button>
                        {/if}
                    {/if}
                {/if}

                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-success " on:click={onSaveTeam}>
                    {#if currentRole.id}
                        Update
                    {:else}
                        Save
                    {/if}
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="addEmployee" tabindex="-1" role="dialog" aria-labelledby="addEmployeeLabel"
     aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addEmployeeLabel">
                    {#if currentEmployee.id}
                        Edit Employee
                    {:else}
                        <span class="text-muted">Add New Employee to</span>
                        <em class="text-dark bg-warning px-1">{roleName}</em>
                    {/if}
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {#if AuthService.can('ANNOTATE_KPI') }
                    <ul class="nav nav-tabs mb-3" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="employee-tab"
                               data-toggle="tab" href="#employee" role="tab" aria-controls="employee" aria-selected="true">
                                Employee
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="notes-tab"
                               data-toggle="tab" href="#notes" role="tab" aria-controls="notes" aria-selected="false">
                                Notes
                            </a>
                        </li>
                    </ul>
                {/if}
                {#if saveTriedAlert}
                    <div class="alert alert-danger" role="alert">
                        Please fill in all required fields
                        <button type="button" class="close" on:click={ () => saveTriedAlert = false}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                {:else if badDatesError}
                    <div class="alert alert-danger" role="alert">
                        Start date must be earlier or equal to end date
                        <button type="button" class="close" on:click={ () => badDatesError = false}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                {/if}
                {#if employeeError}
                    <div class="alert alert-danger" role="alert">
                        {employeeError}
                        <button type="button" class="close" on:click={ () => employeeError = ''}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                {/if}
                <form>
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="employee" role="tabpanel" aria-labelledby="employee-tab">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="nameInput">* Region #</label>
                                        <input bind:value={currentEmployee.region} maxlength="10" type="text" class="form-control" id="nameInput"
                                               placeholder="156">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="nameInput">* Employee #</label>
                                        <input bind:value={currentEmployee.employee_number} maxlength="10" type="text" class="form-control" id="nameInput"
                                            placeholder="443912">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="nameInput">* Name</label>
                                <input bind:value={currentEmployee.name} maxlength="64" type="text" class="form-control" id="nameInput"
                                       placeholder="John Doe">
                            </div>
                            <div class="form-group">
                                <label for="nameInput">* Office</label>
                                <input bind:value={currentEmployee.office} maxlength="64" type="text" class="form-control" id="nameInput"
                                       placeholder="">
                            </div>
                            <div class="form-group">
                                <label for="positionInput">* Job Title</label>
                                <input bind:value={currentEmployee.position} type="text" class="form-control"
                                       id="positionInput" maxlength="40" required placeholder="Management">
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="dateInput">* Start Date: </label>
                                        <input bind:value={currentEmployee.start_date} type="date" class="form-control"
                                               id="dateInput" data-date-format="DD/MMMM/YYYY" placeholder="mm/dd/yyyy">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="dateInput">End Date:</label>
                                        <input bind:value={currentEmployee.end_date} min="2020-05-25" type="date"
                                               class="form-control" id="endDate" data-date-format="DD/MMMM/YYYY"
                                               placeholder="mm/dd/yyyy">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="fulltime">Full Time / Part Time:</label>
                                        <select id="fulltime" bind:value="{currentEmployee.is_fulltime}" class="form-control">
                                            <option value="1" selected={currentEmployee.is_fulltime == 1}>Full Time</option>
                                            <option value="0" selected={currentEmployee.is_fulltime == 0}>Part Time</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="notes" role="tabpanel" aria-labelledby="notes-tab">
                            <div class="form-group">
                                <label for="notesInput">Notes</label>
                                <textarea bind:value={currentEmployee.notes} type="text" class="form-control"
                                    id="notesInput" placeholder="Notes" rows="5"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="notesInput">Skills</label>
                                <textarea bind:value={currentEmployee.skills} type="text" class="form-control"
                                    id="skillsInput" placeholder="Skils" rows="5"></textarea>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            {#if errorMessage}
                <div class="alert alert-danger">
                    ERROR: {errorMessage}
                </div>
            {/if}
            <div class="modal-footer">
                {#if AuthService.can('DELETE_EMPLOYEE') }
                    {#if currentEmployee.id}
                        {#if deleteConfirmation}
                            <div class="alert alert-warning btn-block">
                                <h4>Are you sure you want to delete?</h4>
                                <p>You can set the termination date instead of deleting.</p>
                            </div>
                            <button type="button" class="btn btn-danger mr-auto" on:click={onDeleteEmployee}
                                    disabled={disableButton}>
                                Click to confirm
                            </button>
                        {:else}
                            <button type="button" class="btn btn-danger mr-auto" on:click={setDeleteConfirmation}>
                                DELETE
                            </button>
                        {/if}
                    {/if}
                {/if}
                <button type="button" class="btn btn-secondary" data-dismiss="modal" on:click={cleanEmployee}>Close
                </button>
                <button type="button" class="btn btn-success" on:click={onSaveEmployee} disabled={disableSaveButton}>
                    {#if currentEmployee.id}
                        Update
                    {:else}
                        Save
                    {/if}
                </button>
            </div>
        </div>
    </div>
</div>

{#if loading}
    <Loader fixed={true}></Loader>
{/if}

{#if !teams}
    <h4 class="text-danger text-center">...</h4>
{:else}
    <div id="comments" class="comment-popover d-none"></div>
    {#each teams as team, teamIndex}
        {#if selectedTeam}
            <div class="move-here"
                on:click={ changeTeamPosition(team.id, team.position) }>
                Move here
            </div>
        {/if}
        <div class="table-wrapper { selectedTeam && selectedTeam == team.id ? 'selectedSection' : ''}">
            <table class="table table-sm container-fluid table-weekly selectable-table">
                <thead>
                    <tr class="bg-dark text-light">
                        <th colspan="2" class="col-header">{
                            team.title}
                            {#if AuthService.can('EDIT_TEAM') }
                            <i on:click={ () =>  editRole(team)}
                                class="fa fa-pencil-square-o text-light float-right btn btn-sm px-0"></i>
                        {/if}
                        </th>
                        <th colspan="7"></th>
                        {#each headers as header}
                            <th colspan="{isActualsVsBudgets ? 4 : 1}" class="text-center notFixed">
                                {header.replaceAll('_' , ' ')}
                            </th>
                        {/each}
                    </tr>
                    <tr class="bg-dark text-light">
                        <th class="col-subheader text-left col-region">Region #</th>
                        <th class="col-subheader">Employee #</th>
                        <th class="col-subheader">Name</th>
                        <th class="col-subheader">Office</th>
                        <th class="col-subheader employee-position">Job Title</th>
                        <th class="col-subheader subheader-date">Full Time<br> Part Time</th>
                        <th class="col-subheader subheader-date">Start<br>Date</th>
                        <th class="col-subheader subheader-date">End<br>Date</th>
                        {#if params && params.subMenu !== 'actuals_vs_budget'}
                            <th class="col-subheader subheader-date">Quartile</th>
                        {/if}
                        {#each headers as header}
                            <th class="notFixed">Utilization Rate</th>
                            {#if isActualsVsBudgets}
                                <th class="notFixed">{team.actual_title}</th>
                                <th class="notFixed">{team.budget_title}</th>
                                <th class="notFixed">{team.delta_title}</th>
                            {/if}
                        {/each}
                    </tr>
                </thead>
                <tbody>
                {#each team.employees as employee, employeeIndex}
                    <tr>
                        <td class="col-header col-ops col-region">
                            {employee.region || ''}
                            {#if AuthService.can('EDIT_EMPLOYEE') }
                                <i data-id="{employee.id}"
                                   on:click={ (e) => editEmployee(e, employee) }
                                   class="fa fa-pencil-square-o text-primary float-right btn btn-sm px-0 action-edit"></i>
                            {/if}
                            {#if employee.skills && employee.skills.length > 0}
                                <i data-notes="{employee.skills}"
                                   class="fa fa-sticky-note-o fa-corner-icon float-right btn btn-sm px-0 action-comment"></i>
                            {/if}
                        </td>
                        <td class="col-ops">{employee.employee_number || ''}</td>
                        <td class="col-ops">{employee.name || ''}</td>
                        <td class="col-ops">{employee.office || ''}</td>
                        <td class="col-ops">{employee.position || ''}</td>
                        <td class="col-ops">{employee.is_fulltime === 1 ? 'Full Time' : 'Part Time'}</td>
                        <td class="col-date col-ops">{employee.start_date_formatted || ''}</td>
                        <td class="col-date col-ops">{employee.end_date_formatted || ''}</td>
                        {#if params && params.subMenu !== 'actuals_vs_budget'}
                            <td class="col-date col-ops">{employee.quartile || ''}</td>
                        {/if}
                        {#each headers as header}
                            {#each Object.keys(employee.employeeData[header]) as column, headerIndex}
                                {#if column !== 'utilization_rate' && column != 'open_utilization' && header !== 'last_12_mo'}
                                    <td class="notFixed">
                                        <EditableCell
                                            id="t{teamIndex}-{employeeIndex}-{headerIndex}"
                                            xdata="{ {id: employee.id, report: 'individual', date: getDate(header), field: column} }"
                                            customClass="{!employee.importedValues[header][`${column}_imported`]?'manual-data-kpi':''}"
                                            on:change={(e) => saveEmployeeStat(e.detail.value, employee.id, header, column, employeeIndex, teamIndex)}
                                            bind:value={employee.employeeData[header][column]}
                                            format={team.format}>
                                        </EditableCell>
                                    </td>
                                {:else}
                                <td class="notFixed readOnly 
                                {column === 'utilization_rate' ? getUtilizationColor(employee.employeeData[header][column], budgets[teamIndex][header], team.style, teamIndex, header) : ''}">
                                     {employee.employeeData[header][column]} 
                                </td>
                                {/if}
                            {/each}
                        {/each}
                    </tr>
                {:else}
                     <tr>
                        <th class="col-header">
                            {#if AuthService.can('EDIT_EMPLOYEE') }
                                <i data-id="{team.id}"
                                   on:click={ (e) => fillEmployee(team) }
                                   class="fa fa-pencil-square-o text-primary float-right btn btn-sm px-0 action-edit"></i>
                            {/if}
                            John Doe
                        </th>
                        <td class="col-subheader text-truncate employee-position">Manager</td>
                        <td class="col-date">---</td>
                        <td class="col-date">---</td>
                        {#if params.subMenu =='attainment' ||  params.subMenu == 'quarterly'}
                            <td class="col-date">---</td>
                            <td class="notFixed readOnly rank">---</td>
                        {/if}

                        {#each headers as header}
                            <td class="notFixed readOnly text-light">&emsp;</td>
                        {/each}
                    </tr>
                {/each}
                {#if team.employees.length > 0}
                    <tr class="totals-border">
                        <td colspan="{isActualsVsBudgets ? 7 : 8 }"></td>
                        <td class="total-title">Totals</td>
                        {#each headers as header}
                        {   #if isActualsVsBudgets}
                                {#each Object.keys(totals[teamIndex][header]) as column}
                                    <td class="notFixed readOnly">
                                        {#if column === 'utilization_rate'}
                                            --
                                        {:else}
                                            {totals[teamIndex][header][column].toFixed(2)}
                                        {/if}
                                    </td>
                                {/each}
                            {:else}
                                <td class="notFixed readOnly">--</td>
                            {/if}
                        {/each}
                    </tr>
                    <tr>
                        <td colspan="{isActualsVsBudgets ? 7 : 8 }"></td>
                        <td class="total-title">Average</td>
                        {#each headers as header}
                            {#each Object.keys(totals[teamIndex][header]) as column}
                                    <td class="notFixed readOnly 
                                        {getUtilizationColor((totals[teamIndex][header][column] / team.employees.length).toFixed(2), budgets[teamIndex][header], team.style, teamIndex, column)}">
                                        {(totals[teamIndex][header][column] / team.employees.length).toFixed(2)}
                                        {column === 'utilization_rate' ? '%' : ''}
                                    </td>
                                {/each}
                        {/each}
                    </tr>
                    <tr>
                        <td colspan="{isActualsVsBudgets ? 7 : 8 }"></td>
                        <td class="total-title">Year Over Year</td>
                        {#each headers as header}
                            {#each Object.keys(pyData[teamIndex][header]) as column}
                                <td class="notFixed readOnly">
                                    {pyData[teamIndex][header][column]}
                                </td>
                            {/each}
                        {/each}
                    </tr>
                    <tr>
                        <td colspan="{isActualsVsBudgets ? 7 : 8 }"></td>
                        <td class="total-title">Target</td>
                        {#each headers as header, headerIndex}
                            <td class="notFixed readOnly">
                                {#if header === 'last_12_mo'}
                                    --
                                {:else}
                                    {#if isActualsVsBudgets}
                                    <EditableCell
                                        id="t{teamIndex}-{team.employees.length + 1}-{headerIndex}"
                                        on:change={(e) => saveBudget(e.detail.value, team.id, header)}
                                        bind:value={budgets[teamIndex][header]}
                                        format={2}>
                                        { budgets[teamIndex][header] }
                                    </EditableCell>
                                    {:else}
                                        {formatValue(2, budgets[teamIndex][header])}
                                    {/if}
                                {/if}
                            </td>
                            {#if isActualsVsBudgets}
                                {#each ['parameter1', 'parameter2', 'open_utilization'] as item}
                                    <td class="notFixed readOnly">--</td>
                                {/each}
                            {/if}
                        {/each}
                    </tr>
                {/if}
                <tr class="border-0">
                    <td class="bg-transparent col-header" colspan="12">
                        {#if team.position !== null && AuthService.can('ADD_EMPLOYEE') }
                            <button class="mt-2 btn btn-primary btn-sm text-light float-left"
                                    data-id="{team.id}"
                                    on:click|preventDefault={(e) => fillEmployee(team)}>
                                <i class="fa fa-plus"></i>
                                Add Employee
                            </button>
                        {/if}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    {/each}
{/if}

<style>
    .col-subheader {
        background-color: #F8F8F8;
    }

    .col-region {
        text-align: left;
        padding-left: 10px !important;
    }

    .total-title {
        text-align: left;
        color: #000;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 10px;
    }

    .totals-border {
        border-top: solid black 2px;
    }

    #column-names {
        font-weight: 600;
        font-size: small;
    }

    .col-region {
        width: 115px;
    }
</style>